import Svg, { SvgProps } from './Svg';

export default function SparkLendIcon({ ...props }: SvgProps) {
  const id1 = 'linearGradient-lend' + Math.random().toString(16).slice(2);
  const id2 = 'linearGradient-lend' + Math.random().toString(16).slice(2);
  return (
    <Svg viewBox="0 0 96 96" fill="none" {...props}>
      <path
        d="M45.7375 1.60507L31.8083 31.8083L1.60507 45.7375C0.450372 46.2702 0.830094 48 2.10175 48H48V2.10175C48 0.830098 46.2702 0.45037 45.7375 1.60507Z"
        fill={`url(#${id1})`}
      />
      <path
        d="M50.2625 94.395L64.1918 64.1918L94.395 50.2625C95.5497 49.7299 95.1699 48 93.8985 48H48V93.8983C48 95.1699 49.7299 95.5497 50.2625 94.395Z"
        fill={`url(#${id2})`}
      />
      <defs>
        <linearGradient
          id={id1}
          x1="95.0857"
          y1="0.914304"
          x2="1.09404"
          y2="95.2648"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF895D" />
          <stop offset="1" stopColor="#FFCD4D" />
        </linearGradient>
        <linearGradient
          id={id2}
          x1="95.0857"
          y1="0.914289"
          x2="1.09404"
          y2="95.2648"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF895D" />
          <stop offset="1" stopColor="#FFCD4D" />
        </linearGradient>
      </defs>
    </Svg>
  );
}
